import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any = []

const requireSignaturesSlice = createSlice({
  name: 'requireSignatures',
  initialState,
  reducers: {
    updateRequireSignatures: (state, action: PayloadAction<any>) => action.payload,
  },
  extraReducers: () => {},
})

export const requireSignaturesActionsCreator = requireSignaturesSlice.actions

export default requireSignaturesSlice
